import { debounce } from 'es-toolkit';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _debounce = (func, wait = 25, options) => debounce(func, wait, options);
export { _debounce as debounce };
